import { render } from "./TCalculator.vue?vue&type=template&id=bf077d06&scoped=true"
import script from "./TCalculator.vue?vue&type=script&lang=js"
export * from "./TCalculator.vue?vue&type=script&lang=js"

import "./TCalculator.vue?vue&type=style&index=0&id=bf077d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf077d06"]])

export default __exports__